import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import Alert from "../../components/Alert.jsx";
import MyPage from "../../MyPage.js";
import SubTabsWarehouses from "../../SubTabsWarehouses.js";
import { Blocks } from 'react-loader-spinner'
import { refreshMaterializedView } from "./../../helpers/helpers.js";
import axiosService from '../../helpers/axios';
import { SatelliteContext } from '../../context/SatelliteContext';
import { getSatelliteApiParam, displaySatellite } from '../../helpers/satellite';

  export default class WarehousesOutbound extends Component{
    static contextType = SatelliteContext; 

    constructor(props){
      super(props);

      this.state={
          outbound:[],
          modalTitle:"",
          outboundid:0,
          forecastid:0,
          fyname:"",
          regionname:"",
          warehousename:"",
          productid:0,
          sapcode:"",
          productdescription:"",
          itemtypename:"",
          july:"",
          august:"",
          september:"",
          october: "",
          november: "",
          december: "",
          january: "",
          february: "",
          march: "",
          april: "",
          may: "",
          june:"",

          RegionNameFilter:"",
          WarehouseNameFilter:"",
          FiscalYearFilter:"",
          ProductDescriptionFilter:"",
          ProductIdFilter:"",
          ForecastIdFilter:"",
          OutboundIdFilter:"",
          CurrentYearFilter:"",
          outboundWithoutFilter:[],
          loading: true,
          currentYearIndex: 0,
          currentYear: null,
      }
  }

  FilterFn(){
    var RegionNameFilter = this.state.RegionNameFilter;
    var WarehouseNameFilter = this.state.WarehouseNameFilter;
    var FiscalYearFilter = this.state.FiscalYearFilter;
    var ProductDescriptionFilter = this.state.ProductDescriptionFilter;
    var ForecastIdFilter = this.state.ForecastIdFilter;
    var OutboundIdFilter = this.state.OutboundIdFilter;
    var CurrentYearFilter = this.state.CurrentYearFilter;
    var ProductIdFilter = this.state.ProductIdFilter;

    var filteredData=this.state.outboundWithoutFilter.filter(
        function(el){
            return el.regionname.toString().toLowerCase().includes(
                RegionNameFilter.toString().trim().toLowerCase()
            )&&  
                el.warehousename.toString().toLowerCase().includes(
                WarehouseNameFilter.toString().trim().toLowerCase()
            )&&  
                el.fyname.toString().toLowerCase().includes(
                FiscalYearFilter.toString().trim().toLowerCase()
            )&&  
                el.productdescription.toString().toLowerCase().includes(
                ProductDescriptionFilter.toString().trim().toLowerCase()
            )&&  
            el.outboundid.toString().toLowerCase().includes(
            OutboundIdFilter.toString().trim().toLowerCase()
        )&&  
        el.sapcode.toString().toLowerCase().includes(
        ProductIdFilter.toString().trim().toLowerCase()
    )
        }
    );

    this.setState({outbound:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.outboundWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({outbound:sortedData});

}


changeCountryNameFilter = (e)=>{
  this.state.CountryNameFilter=e.target.value;
  this.FilterFn();
}

changeRegionNameFilter = (e)=>{
    this.state.RegionNameFilter=e.target.value;
    this.FilterFn();
  }

changeWarehouseNameFilter = (e)=>{
    this.state.WarehouseNameFilter=e.target.value;
    this.FilterFn();
  }

changeFiscalYearFilter = (e)=>{
    this.state.FiscalYearFilter=e.target.value;
    this.FilterFn();
  }


changeProductDescriptionFilter = (e)=>{
    this.state.ProductDescriptionFilter=e.target.value;
    this.FilterFn();
  }


changeForecastIdFilter = (e)=>{
    this.state.ForecastIdFilter=e.target.value;
    this.FilterFn();
  }

changeOutboundIdFilter = (e)=>{
    this.state.OutboundIdFilter=e.target.value;
    this.FilterFn();
  }

  changeCurrentYearFilter = (e)=>{
    this.state.CurrentYearFilter=e.target.value;
    this.FilterFn();
  }

  
  changeProductFilter = (e)=>{
    this.state.ProductIdFilter=e.target.value;
    this.FilterFn();
  }



refreshList = () => {
    const params = {};
    const sat = getSatelliteApiParam(this.context?.satellite);
    if (sat) params.satellite = sat;
    axiosService.get('/outbound/', { params })
      .then((response) => {
        const data = response.data;
        const rows = Array.isArray(data) ? data : (data?.results ?? []);
        this.setState({ outbound: rows, outboundWithoutFilter: rows, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };


componentDidUpdate(_prevProps, _prevState) {
  const sat = this.context?.satellite;
  if (this._lastOutboundSatellite !== sat) {
    this._lastOutboundSatellite = sat;
    this.setState({ loading: true });
    this.refreshList();
  }
}

componentDidMount(){
  this._lastOutboundSatellite = this.context?.satellite;
  this.refreshList();
}

render(){
  const {
      outbound,
      modalTitle,
      outboundid,
      forecastid,
      countryname,
      warehousename,
      regionname,
      fyname,
      productdescription,
      july,
      august,
      september,
      october,
      november,
      december,
      january,
      february,
      march,
      april,
      may,
      june,
      loading,
      fiscalYears,
      currentYearIndex,
      currentYear

  }=this.state;

  //const currentYear = fiscalYears[currentYearIndex];

  return(
    
<div className="scrollable-container">
<MyPage />
<SubTabsWarehouses />
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px"  }} 
      onChange={this.changeFiscalYearFilter}
      value={currentYear}
      placeholder="Filter"/>
      </div>
      Fiscal Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeRegionNameFilter}
      placeholder="Filter"/>

      </div>
      Region
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeWarehouseNameFilter}
      placeholder="Filter"/>
      </div>
      Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "150px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductFilter}
      placeholder="Filter"/>

      </div>
      Product SAP Code / SKU
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Satellite
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "200px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductDescriptionFilter}
      placeholder="Filter"/>

      </div>
      Product
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jul
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Aug
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Sep
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Oct
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Nov
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}> 
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Dec
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jan
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Feb
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Mar
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Apr
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      May
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jun
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {outbound.map(dep=>
      <tr key={dep.outboundid} className="row-hover">
          <td className="table-text">{dep.fyname ?? 'N/A'}</td>
          <td className="table-text">{dep.regionname ?? 'N/A'}</td>
          <td className="table-text">{dep.warehousename ?? 'N/A'}</td>
          <td className="table-text">{dep.sapcode ?? 'N/A'}</td>
          <td className="table-text">{displaySatellite(dep.satellite, { csv: true })}</td>
          <td className="table-text">{dep.productdescription ?? 'N/A'}</td>
          <td className="table-text">{dep.july ?? 'N/A'}</td>
          <td className="table-text">{dep.august ?? 'N/A'}</td>
          <td className="table-text">{dep.september ?? 'N/A'}</td>
          <td className="table-text">{dep.october ?? 'N/A'}</td>
          <td className="table-text">{dep.november ?? 'N/A'}</td>
          <td className="table-text">{dep.december ?? 'N/A'}</td>
          <td className="table-text">{dep.january ?? 'N/A'}</td>
          <td className="table-text">{dep.february ?? 'N/A'}</td>
          <td className="table-text">{dep.march ?? 'N/A'}</td>
          <td className="table-text">{dep.april ?? 'N/A'}</td>
          <td className="table-text">{dep.may ?? 'N/A'}</td>
          <td className="table-text">{dep.june ?? 'N/A'}</td>
          <td>

          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>



</div>
  )
}
  }




